var _defs, _circle, _circle2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradBlue2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e40af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradPurple2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6d28d9"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 350,
    r: 80,
    fill: "url(#gradPurple2)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "80;90;80",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 60,
    fill: "url(#gradBlue2)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;70;60",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 200)",
    className: "main-group"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "transform",
    values: "translate(300, 200) scale(1); translate(300, 200) scale(1.02); translate(300, 200) scale(1)",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -80,
    width: 240,
    height: 160,
    rx: 10,
    fill: "#f8fafc",
    stroke: "#cbd5e1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -35,
    r: 30,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -35,
    r: 15,
    fill: "#94a3b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15,5 L15,5 C20,5 25,10 25,15 L25,35 C25,40 20,45 15,45 L-15,45 C-20,45 -25,40 -25,35 L-25,15 C-25,10 -20,5 -15,5 Z",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 0,
    width: 140,
    height: 10,
    rx: 2,
    fill: "#94a3b8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 20,
    width: 140,
    height: 10,
    rx: 2,
    fill: "#94a3b8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 40,
    width: 80,
    height: 15,
    rx: 7.5,
    fill: "url(#gradPurple2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.8;1",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -140,
    cy: -40,
    r: 15,
    fill: "url(#gradBlue2)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "-40;-30;-40",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 40,
    r: 12,
    fill: "url(#gradPurple2)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "40;50;40",
    dur: "5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-140,40 L-150,30 L-140,20 Z",
    fill: "url(#gradBlue2)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "transform",
    values: "rotate(0); rotate(360)",
    attributeType: "XML",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 130)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "url(#gradPurple2)"
  }, "JOIN NOW"), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIllustration);
export default __webpack_public_path__ + "static/media/register-illustration.ed1e13cb10e91abc5dc576c6cbf17e77.svg";
export { ForwardRef as ReactComponent };